import { useEffect, useRef, useState } from "react";
import HanziWriter from "hanzi-writer";
import { Play, PenLine } from "lucide-react";
import { sfx } from "../../lib/audio";
import { TraceCanvas } from "./TraceCanvas";

// Stroke-order animation + guided stroke tracing; falls back to shape tracing if stroke data is unavailable.
export const HanziTrace = ({ char, onComplete }) => {
  const el = useRef(null);
  const writer = useRef(null);
  const [fallback, setFallback] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    setFallback(false);
    setDone(false);
    if (!el.current) return;
    el.current.innerHTML = "";
    writer.current = HanziWriter.create(el.current, char, {
      width: 300, height: 300, padding: 20, showOutline: true, showCharacter: false,
      strokeColor: "#C83E2B", outlineColor: "#EADBC4", highlightColor: "#F59E0B", drawingColor: "#C83E2B",
      drawingWidth: 28, showHintAfterMisses: 1, strokeAnimationSpeed: 1, delayBetweenStrokes: 250,
      onLoadCharDataError: () => setFallback(true),
    });
    return () => { writer.current = null; };
  }, [char]);

  const animate = () => writer.current?.animateCharacter();
  const quiz = () => {
    setDone(false);
    writer.current?.hideCharacter();
    writer.current?.quiz({
      leniency: 1.5,
      onCorrectStroke: () => sfx("tap"),
      onComplete: () => { sfx("good"); setDone(true); onComplete && onComplete(); },
    });
  };

  if (fallback) return <TraceCanvas glyph={char} onComplete={onComplete} testid="char-trace-canvas" />;
  return (
    <div className="flex flex-col items-center gap-4" data-testid="hanzi-trace">
      <div className={`relative rounded-3xl bg-white border-4 ${done ? "border-[var(--jade)]" : "border-[var(--line)]"}`} style={{ width: 300, height: 300 }}>
        <svg className="absolute inset-0 pointer-events-none" width="300" height="300">
          <line x1="150" y1="6" x2="150" y2="294" stroke="#EADBC4" strokeDasharray="6 6" />
          <line x1="6" y1="150" x2="294" y2="150" stroke="#EADBC4" strokeDasharray="6 6" />
        </svg>
        <div ref={el} className="relative" data-testid="hanzi-writer-target" />
        {done && <div className="absolute -top-4 -right-4 text-5xl" data-testid="hanzi-trace-success">🌟</div>}
      </div>
      <div className="flex gap-3">
        <button data-testid="stroke-animate-btn" onClick={animate} className="kid-btn px-5 bg-amber-100 text-[var(--tea)] flex items-center gap-2"><Play /> 筆順</button>
        <button data-testid="stroke-quiz-btn" onClick={quiz} className="kid-btn px-6 bg-[var(--jade)] text-white flex items-center gap-2"><PenLine /> 描一描</button>
      </div>
    </div>
  );
};
